import React, { useState } from 'react';
import './FileDrop.scss';

type FileDropProps = {
  accept: string;
  hint: string;
  fileName?: string | null;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const FileDrop: React.FC<FileDropProps> = ({
  accept,
  hint,
  fileName,
  disabled = false,
  onChange,
}) => {
  const [dragging, setDragging] = useState(false);

  const className =
    'file-drop' +
    (dragging ? ' file-drop--dragging' : '') +
    (fileName ? ' file-drop--filled' : '') +
    (disabled ? ' file-drop--disabled' : '');

  return (
    <div className={className}>
      <span className="file-drop__icon" aria-hidden>
        {fileName ? '✓' : '+'}
      </span>
      <span className="file-drop__text">
        <strong className="file-drop__title">
          {fileName ?? 'Drop your file here or click to browse'}
        </strong>
        <span className="file-drop__hint">
          {fileName ? 'Click or drop another file to replace it.' : hint}
        </span>
      </span>
      <input
        className="file-drop__input"
        type="file"
        accept={accept}
        disabled={disabled}
        onChange={(event) => {
          setDragging(false);
          onChange(event);
        }}
        onDragEnter={() => setDragging(true)}
        onDragLeave={() => setDragging(false)}
        onDrop={() => setDragging(false)}
      />
    </div>
  );
};

export default FileDrop;
